/**
 * api接口统一管理
 */
import { get, post, post1,post2,get1 } from './http'


// 首页
export const homeImg = p => post('/hzsys/student/official/imageTextList?' + p)

// 首页师资标签
export const homeTag = p => post('/hzsys/student/official/selTagList')

// 教师集合
export const homeTeacher = p => post('/hzsys/student/official/selHzTeacherList')

// 校区集合
export const campusList = p => post('/hzsys/student/official/campusList')

// 招聘集合
export const jobFair = p => post('/hzsys/student/official/selInviteList?' + p)

// 动态集合
export const dynamicList = p => post('/hzsys/student/official/selDynamicList?' + p)

// 动态集合-新闻详情
export const dynamicListDetail = p => post('/hzsys/student/official/selByDynamic?' + p)

// 获取页面信息与资料
export const pagesDetail = p => post1('/learn/senior/exam/pages/detail?' + p)

// 获取验证码
export const getCode = p => post1('/learn/senior/exam/pages/sendAuthCode?' + p)

// 页面登记
export const register = p => post1('/learn/senior/exam/pages/register?', p)

/**
 * 下载文件
 */
export const downloadFileApi = fileId => get1('/learn/senior/exam/pages/downLoad/file?fileId=' + fileId)